import { render, staticRenderFns } from "./ContentUser.vue?vue&type=template&id=4850cf3f&scoped=true&"
import script from "./ContentUser.vue?vue&type=script&lang=js&"
export * from "./ContentUser.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ContentUser.vue?vue&type=style&index=0&id=4850cf3f&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4850cf3f",
  null
  ,true
)

export default component.exports